import React from "react";
import { useNavigate } from "react-router-dom";
import { getBandeiraUrl } from "../utils/bandeiras";
import "./JogoCard.css";

export default function JogoCard({ jogo }) {
  const navigate = useNavigate();
  
  if (!jogo || !jogo.selecaoMandante || !jogo.selecaoVisitante) {
    return null;
  }

  const mandante = jogo.selecaoMandante;
  const visitante = jogo.selecaoVisitante;
  
  // Formatar data e hora
  const dataHora = new Date(jogo.dataHoraJogo);
  const dataFormatada = dataHora.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const horaFormatada = dataHora.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Verificar se o jogo já começou
  const agora = new Date();
  const jogoComecou = dataHora <= agora;
  const resultado = jogo.golsMandante !== null && jogo.golsVisitante !== null;

  const handlePalpitar = () => {
    navigate(`/palpitar/${jogo.id}`);
  };

  return (
    <div className="jogo-card">
      <div className="jogo-header">
        <span className="jogo-data">{dataFormatada}</span>
        <span className="jogo-hora">{horaFormatada}</span>
      </div>

      <div className="jogo-confronto">
        <div className="selecao mandante">
          <div className="bandeira">
            {getBandeiraUrl(mandante.sigla) ? (
              <img 
                src={getBandeiraUrl(mandante.sigla)} 
                alt={mandante.sigla}
                className="bandeira-img"
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
              />
            ) : null}
            <span className="bandeira-sigla" style={{ display: getBandeiraUrl(mandante.sigla) ? 'none' : 'block' }}>
              {mandante.sigla}
            </span>
          </div>
          <div className="nome">{mandante.nome}</div>
        </div>

        <div className="versus">
          {resultado ? (
            <div className="resultado">
              <span className="gols">{jogo.golsMandante}</span>
              <span className="separador">x</span>
              <span className="gols">{jogo.golsVisitante}</span>
            </div>
          ) : (
            <span className="vs">VS</span>
          )}
        </div>

        <div className="selecao visitante">
          <div className="bandeira">
            {getBandeiraUrl(visitante.sigla) ? (
              <img 
                src={getBandeiraUrl(visitante.sigla)} 
                alt={visitante.sigla}
                className="bandeira-img"
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
              />
            ) : null}
            <span className="bandeira-sigla" style={{ display: getBandeiraUrl(visitante.sigla) ? 'none' : 'block' }}>
              {visitante.sigla}
            </span>
          </div>
          <div className="nome">{visitante.nome}</div>
        </div>
      </div>

      <div className="jogo-info">
        <div className="estadio">{jogo.grupo?.nome || "Fase de Grupos"}</div>
      </div>

      {!jogoComecou && !resultado && (
        <button className="btn-palpitar" onClick={handlePalpitar}>
          Fazer Palpite
        </button>
      )}

      {resultado && (
        <div className="badge-resultado">Resultado Lançado</div>
      )}

      {jogoComecou && !resultado && (
        <div className="badge-em-andamento">Em Andamento</div>
      )}
    </div>
  );
}
